module.exports = __webpack_public_path__ + "static/media/bill.b85eae1e.svg";